const MAX_CHARS = 8192

function normalize(value: string): string {
    return value.trim().replace(/\s+/g, ' ')
}

function levenshtein(a: string, b: string): number {
    if (a === b) {
        return 0
    }
    if (a.length === 0) {
        return b.length
    }
    if (b.length === 0) {
        return a.length
    }

    let prev = new Array<number>(b.length + 1)
    let curr = new Array<number>(b.length + 1)
    for (let j = 0; j <= b.length; j++) {
        prev[j] = j
    }

    for (let i = 1; i <= a.length; i++) {
        curr[0] = i
        for (let j = 1; j <= b.length; j++) {
            const cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1
            curr[j] = Math.min(prev[j] + 1, curr[j - 1] + 1, prev[j - 1] + cost)
        }
        const swap = prev
        prev = curr
        curr = swap
    }

    return prev[b.length]
}

/**
 * Trim + collapse whitespace, case preserved, Levenshtein / max(len), 3 dp.
 * Both empty → 0. Either side > 8192 chars → null (skip the write).
 */
export function normalizedEditDistance(a: string, b: string): number | null {
    const left = normalize(a)
    const right = normalize(b)
    if (left.length > MAX_CHARS || right.length > MAX_CHARS) {
        return null
    }
    if (left.length === 0 && right.length === 0) {
        return 0
    }
    const denom = Math.max(left.length, right.length)
    return Math.round((levenshtein(left, right) / denom) * 1000) / 1000
}
